import React from 'react';
import classnames from 'classnames';
import { TextArea } from '@1c/ui';
import Text from 'src/components/Text';
import styles from './styles.module.scss';

type Props = {
  label?: string;
  error?: string;
  className?: string;
  [x: string]: any;
}

const TextAreaField: React.FC<Props> = ({ label, error, className, ...rest }) => {
  const fieldClassNames = classnames(styles['input-field'], className);
  
  return (
    <div className={fieldClassNames}>
      {label && <Text type="span" muted className={styles['label']}>{label}</Text>}
      <TextArea
        {...rest}
        className={styles['input']}
      />
      {error && <Text type="span" small className={styles['error']}>{error}</Text>}
    </div>
  );
};

export default TextAreaField;
